import { render, staticRenderFns } from "./ClientPropertyPopUp.vue?vue&type=template&id=7b80613a&scoped=true&"
import script from "./ClientPropertyPopUp.vue?vue&type=script&lang=js&"
export * from "./ClientPropertyPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ClientPropertyPopUp.vue?vue&type=style&index=0&id=7b80613a&prod&scoped=true&lang=scss&"
import style1 from "./ClientPropertyPopUp.vue?vue&type=style&index=1&id=7b80613a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b80613a",
  null
  
)

export default component.exports